import React from "react";
import ReactDOM from "react-dom";
import { Provider } from "react-redux";
import { PersistGate } from "redux-persist/integration/react";
import { IntlProvider } from "react-intl";
import { SnackbarProvider } from "notistack";
import currentLocale from "current-locale";
import flattenObject from "flat";
import { uniq, some } from "lodash";
import { store, persistor } from "./Store";
import Router from "./Router";
import * as serviceWorker from "./serviceWorker";
import firebase from "./config/firebase";
import { DEFAULT_LOCALE } from "./config/constants";
import translations from "./config/translations";
import { timeZoneDate } from "./utils/misc";

import { DefaultTheme } from "./ThemeProvider";

import "typeface-roboto";
import "./index.css";

let ip;
// const allowedDomains = ["@chillipepper.co.za", "@707.co.za"];
const allowedDomains = [];
const allowedEmail = [
  "dewet@707.co.za",
  "adele@chillipepper.co.za",
  "andre@707.co.za",
  "andre@chillipepper.co.za",
  "odette@chillipepper.co.za",
  "kylie@chillipepper.co.za",
  "brett@chillipepper.co.za",
  "pc@chillipepper.co.za",
  "admin@chillipepper.co.za",
  "assistant@chillipepper.co.za",
  "brett@waterstone.co.za",
  "odette@waterstone.co.za",
  "pc@waterstone.co.za",
  "andre@waterstone.co.za",
  "adele@waterstone.co.za",
  "kylie@waterstone.co.za",
  "admin@waterstone.co.za",
  "assistant@waterstone.co.za",
  "brandon@socialmediashopza.com",
];
const whitelistIps = ["154.66.251.238"];
const allowedEmailWithIp = [
  "odette@chillipepper.co.za",
  "kylie@chillipepper.co.za",
];

const getLocale = () =>
  currentLocale({
    supportedLocales: [DEFAULT_LOCALE], // kinda useless right now, but this is the groundwork for when we support multiple locales
    fallbackLocale: DEFAULT_LOCALE,
  });

const getMessages = (locale) => {
  const phrases = translations[locale]
    ? translations[locale]
    : translations[DEFAULT_LOCALE];
  return flattenObject(phrases);
};

const startApp = () => {
  const locale = getLocale();

  ReactDOM.render(
    // <AppContainer>
    <IntlProvider
      locale={locale}
      defaultLocale={DEFAULT_LOCALE}
      messages={getMessages(locale)}
    >
      <Provider store={store}>
        <PersistGate loading={<div>LOCAL STORAGE</div>} persistor={persistor}>
          <DefaultTheme>
            <SnackbarProvider
              maxSnack={3}
              anchorOrigin={{
                vertical: "bottom",
                horizontal: "right",
              }}
            >
              <Router />
            </SnackbarProvider>
          </DefaultTheme>
        </PersistGate>
      </Provider>
    </IntlProvider>,
    // </AppContainer>,
    document.getElementById("root")
  );

  serviceWorker.unregister();
};

const writeUser = async (user) => {
  try {
    const date = timeZoneDate();
    const { uid, displayName, email } = user;
    const ref = firebase.db.collection("users").doc(user.uid);
    let u = await ref.get();

    if (u && u.exists) {
      u = u.data();
      return ref.update({
        ip: uniq([ip, ...(u.ip || [])]),
        lastLogin: date,
      });
    }

    return ref.set({
      uid,
      displayName,
      email,
      ip: [ip],
      lastLogin: date,
    });
  } catch (e) {
    console.error("Error committing user to DB", e);
  }
};

const getIp = async () => {
  try {
    const response = await fetch("https://api.ipify.org?format=json");
    const responseBody = await response.json();
    ip = responseBody.ip;
  } catch (e) {
    ip = "0.0.0.0";
  }
};

firebase.auth.onAuthStateChanged(async (user) => {
  if (!ip) {
    await getIp();
  }

  if (user) {
    if (
      !(
        some(allowedDomains, (domain) => user.email.includes(domain)) ||
        some(allowedEmail, (email) => user.email.includes(email)) ||
        (some(allowedEmailWithIp, (email) => user.email.includes(email)) &&
          whitelistIps.includes(ip))
      )
    ) {
      await writeUser(user);
      firebase.auth.signOut();
      console.info("UserAuth: logged out - not permitted");
      alert("Login not permitted");
    } else {
      console.info("UserAuth: logged in");
    }

    startApp();
    writeUser(user);
  } else {
    console.info("UserAuth: not logged in");
    startApp();
  }
});
